import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © 2025 &nbsp;&nbsp; Comverex, LLC &nbsp;&nbsp; All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
